// extracted by mini-css-extract-plugin
export default {"block":"banner3_block__hzY-9","img":"banner3_img__oPsHJ","info":"banner3_info__BDba4","icon":"banner3_icon__ie5hc","title":"banner3_title__S1iTd","text":"banner3_text__ahaMW"};